import { Flex, IconButton, Image, VStack, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { MdMenu } from "react-icons/md";
import { getSkin } from "../../skins";

export const MobileAppBarHeight = 56;

interface AppBarProps {
  children?: React.ReactNode;
  onMenuOpen: () => void;
}

const AppBar: React.FC<AppBarProps> = ({ children, onMenuOpen }) => {
  var bgColor = useColorModeValue('#eef7f4', '#001310');
  const skin = getSkin();
  return (
    <VStack spacing={0} boxShadow="md" height={`${MobileAppBarHeight}px`}>
      <Flex
        direction="row"
        align="center"
        justify="start"
        p={2}
        width="100%"
        bgColor={bgColor}
      >
        <Image src={skin.logo} alt="Logo" width="40px" />
        <IconButton
          aria-label='Open Menu'
          icon={<MdMenu />}
          // colorScheme="primary"
          // color="black"
          onClick={onMenuOpen}
          variant="ghost"
          mx={1}
          borderRadius={99}
        />
        {children}
      </Flex>
    </VStack>
  );
};

export default AppBar;